import store from './store'
import { Message } from 'element-ui'
import { getToken, getDigToken } from '@/utils/auth' // get token from cookie
import { parsePath } from '@/utils/parse' // get token from cookie
const { VARS: VARS_USER } = require('@/api/user/user') // get token from cookie

// 查看是否有digToken
const start = async() => {
  const digToken = getDigToken()
  if (!digToken) {
    try {
      // get digToken
      await store.dispatch('user/getSafeToken')
    } catch (error) {
      console.log('err')
      Message.error(error || 'Has Error')
    }
  }
  const fullPath = window.location.href
  let hasToken = getToken()
  if (hasToken) {
    const name = store.getters.name
    // 用户信息不完整，重新加载！
    if (!name) {
      try {
        // get user info
        await store.dispatch('user/getInfo')
      } catch (error) {
        // remove token and go to login page to re-login
        await store.dispatch('user/resetToken')
        Message.error(error || 'Has Error')
      }
    }
    // 重新获取token
    hasToken = getToken()
  }
  // 验证地址是否为 '/login'   是的话跳转
  if (hasToken) {
    // 当前页面为用户激活页面 且 用户状态为待激活状态
    if (fullPath.indexOf('register.html') !== -1 || (fullPath.indexOf('login.html') !== -1 && (fullPath.indexOf('activate') === -1 || store.getters.status !== VARS_USER.STATUS.WAIT.value))) {
      // 解析地址获取 redirect 跳转
      const { query } = parsePath(window.location.href)
      window.location.href = query.redirect ? decodeURIComponent(query.redirect) : '/own.html'
    }
  } else {
    if (fullPath.indexOf('own.html') !== -1 || fullPath.indexOf('order.html') !== -1 || fullPath.indexOf('cashier.html') !== -1) {
      window.location.href = '/login.html'
    }
  }
}
start()



// WEBPACK FOOTER //
// ./src/permission.js